import React, { useState, useEffect, useRef } from "react";
import Header from "../../../Componets/Header";
import toast from "react-hot-toast";
import moment from "moment";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import Loadercomponent from "../../../Componets/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";

const SalesReportReplica = () => {
  const [loader, setLoader] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [reportData, setReportData] = useState(null);
  let componentRef = useRef();

  const headers = {
    name: "Daily Sales Report",
    components: [
      {
        type: "range",
        name: "date",
        value: {
          start: moment().format("YYYY-MM-DD"),
          end: moment().format("YYYY-MM-DD"),
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Daily Sales",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        date: tabledata?.date,
        source: "Daily Sales Report",
      };

      const invoicesData = await get_all_invoices(data);

      if (invoicesData?.status) {
        setInvoices(invoicesData?.data?.data || []);
        processReportData(invoicesData?.data?.data || []);
        setLoader(false);
      } else {
        toast?.error(invoicesData?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const processReportData = (invoices) => {
    const totalSales = invoices.reduce(
      (sum, invoice) => sum + invoice.total,
      0
    );
    const totalTransactions = invoices.length;

    const taxAmount = invoices.reduce(
      (sum, invoice) => sum + (invoice.taxamount || 0),
      0
    );

    const paymentMethods = {};
    invoices.forEach((invoice) => {
      if (invoice.payments && invoice.payments.length > 0) {
        invoice.payments.forEach((payment) => {
          if (paymentMethods[payment.name]) {
            paymentMethods[payment.name] += payment.amount;
          } else {
            paymentMethods[payment.name] = payment.amount;
          }
        });
      }
    });

    const payments = Object.keys(paymentMethods).map((method) => ({
      method,
      amount: paymentMethods[method],
    }));

    const discountTotal = invoices.reduce(
      (sum, invoice) => sum + invoice.discount,
      0
    );
    const discountCount = invoices.filter(
      (invoice) => invoice.discount > 0
    ).length;

    // Get date range from header
    const dateRange = header.components.find(c => c.name === "date")?.value;
    const startDate = dateRange?.start ? moment(dateRange.start).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY");
    const endDate = dateRange?.end ? moment(dateRange.end).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY");

    const dateDisplay = startDate === endDate ? startDate : `${startDate} - ${endDate}`;

    const processedData = {
      storeName: "Your Store Name",
      country: "Oman",
      title: "Daily Sales Report",
      sessionId: `Session/${moment().format("YYYYMMDD")}`,
      dateRange: dateDisplay,
      sales: [
        {
          name: "Total Sales",
          details: "All transactions",
          qty: totalTransactions,
          amount: totalSales,
        },
      ],
      taxes: {
        label: "TAX",
        amount: taxAmount,
      },
      payments: payments,
      discounts: {
        count: discountCount,
        amount: discountTotal,
      },
      sessionControl: {
        total: totalSales,
        transactions: totalTransactions,
        name: "Session Total",
        expected: totalSales + taxAmount,
      },
      note: "Automatically generated sales report",
    };

    setReportData(processedData);
  };

  const downloadPDF = () => {
    if (!reportData) {
      toast.error("No report data available to download");
      return;
    }

    try {
      const {
        storeName,
        country,
        title,
        sessionId,
        dateRange,
        sales,
        taxes,
        payments,
        discounts,
        sessionControl,
        note,
      } = reportData;

      const doc = new jsPDF();
      registerCairoFont(doc);
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");

      doc.setFontSize(16);
      doc.text(title, pageWidth / 2, 15, { align: "center" });

      doc.setFontSize(10);
      doc.text(`Session ID: ${sessionId}`, pageWidth / 2, 22, { align: "center" });
      doc.text(`Date: ${dateRange}`, pageWidth / 2, 28, { align: "center" });

      let startY = 35;

      doc.setFontSize(12);
      doc.text("Sales", 14, startY);

      const salesData = sales.map(s => [
        s.name,
        s.qty.toString(),
        formatCurrencyPDF(s.amount)
      ]);

      salesData.push([
        "Total",
        sales.reduce((a, b) => a + b.qty, 0).toString(),
        formatCurrencyPDF(sales.reduce((a, b) => a + b.amount, 0))
      ]);

      autoTable(doc, {
        startY: startY + 5,
        head: [["Name", "Quantity", "Amount"]],
        body: salesData,
        theme: 'grid',
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2,
          fontSize: 9
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },
      });

      const salesEnd = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("Taxes on Sales", 14, salesEnd);

      autoTable(doc, {
        startY: salesEnd + 5,
        body: [[taxes.label, formatCurrencyPDF(taxes.amount)]],
        theme: 'grid',
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2,
          fontSize: 9
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },
        columnStyles: {
          0: { fontStyle: 'bold' },
          1: { fontStyle: 'bold', halign: 'right' }
        }
      });

      const taxesEnd = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("Payments", 14, taxesEnd);

      const paymentData = payments.map(p => [
        p.method,
        formatCurrencyPDF(p.amount)
      ]);

      autoTable(doc, {
        startY: taxesEnd + 5,
        head: [["Payment Method", "Amount"]],
        body: paymentData,
        theme: 'grid',
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2,
          fontSize: 9
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },
      });

      const paymentsEnd = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("Discounts", 14, paymentsEnd);

      const discountData = [
        ["Number of discounts", discounts.count.toString()],
        ["Amount of discounts", formatCurrencyPDF(discounts.amount)]
      ];

      autoTable(doc, {
        startY: paymentsEnd + 5,
        body: discountData,
        theme: 'grid',
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2,
          fontSize: 9
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },
      });

      const discountsEnd = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text("Session Control", 14, discountsEnd);

      const sessionData = [
        ["Total", formatCurrencyPDF(sessionControl.total)],
        ["Number of transactions", sessionControl.transactions.toString()],
        ["Name", sessionControl.name],
        ["Expected", formatCurrencyPDF(sessionControl.expected)]
      ];

      autoTable(doc, {
        startY: discountsEnd + 5,
        body: sessionData,
        theme: 'grid',
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [7, 181, 83],
          lineWidth: 0.2,
          fontSize: 9
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [7, 181, 83],
          lineWidth: 0.6
        },
        columnStyles: {
          1: { halign: 'right' }
        }
      });

      const sessionEnd = doc.lastAutoTable.finalY + 10;
      if (note) {
        doc.setFontSize(9);
        doc.text(`Opening of session note: ${note}`, 14, sessionEnd);
      }

      const formattedDate = moment().format('DD_MM_YYYY');
      doc.save(`Sales_Report_${formattedDate}.pdf`);
      toast.success("PDF downloaded successfully");

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF file");
    }
  };

  const formdata = (data) => {
    fetchData(data);
  };

  useEffect(() => {
    fetchData({
      date: {
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
      },
    });
  }, []);

  if (loader) {
    return (
      <div className="max-w-3xl mx-auto p-6 bg-white text-center">
        Loading report data...
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-3xl mx-auto p-6 bg-white text-center">
        No report data available
      </div>
    );
  }

  const {
    storeName,
    country,
    title,
    sessionId,
    dateRange,
    sales,
    taxes,
    payments,
    discounts,
    sessionControl,
    note,
  } = reportData;

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <div>
          <div className="text-right flex gap-3 justify-end mt-4">
            <ReactToPrint
              trigger={() => (

                <Button
                  className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                  type="primary"
                >
                  Download PDF
                </Button>
              )}
              content={() => componentRef}
              pageStyle={`
                           @page {
                             size: landscape;
                             margin: 10mm;
                           }
             
                           @media print {
                             tfoot {
                               position: static !important;
                               bottom: auto !important;
                             }
                             thead { 
                               display: table-header-group !important;
                             }
                             tfoot {
                               display: table-row-group !important;
                             }
                           }
             
                             table {
                             border-collapse: collapse;
                             width: 100%;
                           }
                           th, td {
                             border: 1px solid #ddd;
                             padding: 6px;
                           }
                           th {
                             background-color: #f4f4f4;
                           }
                         `}
            />
          </div>
        </div>

        <ScrollWrapper>

          <div ref={(el) => (componentRef = el)} className="max-w-3xl mx-auto p-6 bg-white text-gray-900 rounded-2xl shadow-md print:shadow-none print:max-w-full print:p-0">
            <header className="mb-6 text-center">
              <h3 className="text-lg font-semibold">{title}</h3>
              <p className="text-sm">
                Session ID: <span className="font-medium">{sessionId}</span>
              </p>

              <p className="text-sm text-gray-600 mt-2">Date: {dateRange}</p>
            </header>

            <section className="mb-5">
              <h4 className="text-sm font-semibold mb-2">Sales</h4>
              <table className="w-full text-sm border-collapse">
                <thead className="sr-only">
                  <tr>
                    <th>Name</th>
                    <th className="text-right">Qty</th>
                    <th className="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {sales.map((s, i) => (
                    <tr key={i} className="border-b last:border-b-0">
                      <td className="py-2">
                        <div className="font-medium">{s.name}</div>
                        {s.details && (
                          <div className="text-xs text-gray-600">{s.details}</div>
                        )}
                      </td>
                      <td className="py-2 text-right">{s.qty}</td>
                      <td className="py-2 text-right">
                        {formatCurrency(s.amount)}
                      </td>
                    </tr>
                  ))}
                  <tr className="font-semibold">
                    <td className="pt-3">Total</td>
                    <td className="pt-3 text-right">
                      {sales.reduce((a, b) => a + b.qty, 0)}
                    </td>
                    <td className="pt-3 text-right">
                      {formatCurrency(sales.reduce((a, b) => a + b.amount, 0))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section className="mb-5">
              <h4 className="text-sm font-semibold mb-2">Taxes on sales</h4>
              <div className="flex justify-between text-sm border rounded p-3">
                <div>
                  <div className="font-medium">{taxes.label}</div>
                </div>
                <div className="text-right font-semibold">
                  {formatCurrency(taxes.amount)}
                </div>
              </div>
            </section>

            <section className="mb-5">
              <h4 className="text-sm font-semibold mb-2">Payments</h4>
              <ul className="text-sm">
                {payments.map((p, i) => (
                  <li key={i} className="flex justify-between border-b py-2">
                    <span>
                      {p.method}{" "}
                      {p.note ? (
                        <span className="text-gray-600">/{p.note}</span>
                      ) : null}
                    </span>
                    <span className="font-medium">{formatCurrency(p.amount)}</span>
                  </li>
                ))}
              </ul>
            </section>

            <section className="mb-5">
              <h4 className="text-sm font-semibold mb-2">Discounts</h4>
              <div className="text-sm border rounded p-3">
                <div>
                  Number of discounts:{" "}
                  <span className="font-medium">{discounts.count}</span>
                </div>
                <div>
                  Amount of discounts:{" "}
                  <span className="font-medium">
                    {formatCurrency(discounts.amount)}
                  </span>
                </div>
              </div>
            </section>

            <section className="mb-6">
              <h4 className="text-sm font-semibold mb-2">Session Control</h4>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="border rounded p-3">
                  <div>
                    Total:{" "}
                    <span className="font-medium">
                      {formatCurrency(sessionControl.total)}
                    </span>
                  </div>
                  <div>
                    Number of transactions:{" "}
                    <span className="font-medium">
                      {sessionControl.transactions}
                    </span>
                  </div>
                </div>
                <div className="border rounded p-3">
                  <div className="text-xs text-gray-600">Name</div>
                  <div className="font-medium">{sessionControl.name}</div>
                  <div className="text-xs text-gray-600">Expected</div>
                  <div className="font-medium">
                    {formatCurrency(sessionControl.expected)}
                  </div>
                </div>
              </div>
            </section>

            {note && (
              <footer className="text-sm text-gray-600 border-t pt-3">
                <div>Opening of session note: {note}</div>
              </footer>
            )}
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

function formatCurrency(value) {
  return `${Number(value).toFixed(3)}`;
}

function formatCurrencyPDF(value) {
  return `${Number(value).toFixed(3)} OMR`;
}

export default SalesReportReplica;